import classNames from 'classnames';
import type { ElementType } from 'react';

import { PayloadSlateRenderer } from '@/src/components/PayloadSlateRenderer/PayloadSlateRenderer';
import type { Intro as IntroType } from '@/types';
import { slugify } from '@/util/strings/slugify';

import { Byline } from '../Byline/Byline';
import { TitleHighlighter } from '../TitleHighlighter/TitleHighlighter';

import styles from './Intro.module.scss';

export function Intro({
    classes,
    className,
    title,
    body,
    byline,
    hasBackground,
    isHero,
}: Intro.Props) {
    const TitleTag = (isHero ? 'h1' : 'h3') as ElementType;
    const ChipTag = (isHero ? 'h3' : 'h4') as ElementType;

    return (
        <div
            className={classNames(styles.wrapper, className, {
                [styles.hero]: isHero,
                [styles.hasBackground]: hasBackground,
            })}
            data-intro={title ? slugify(title) : true}
            data-intro-is-hero={isHero}
        >
            {byline && byline.text && (
                <Byline
                    className={classes?.byline}
                    text={byline.text}
                    type={byline.type}
                    url={byline.url?.path}
                    TagName={ChipTag}
                />
            )}
            {title && (
                <TitleTag className={classNames(styles.title, classes?.title)}>
                    <TitleHighlighter>{title}</TitleHighlighter>
                </TitleTag>
            )}
            {body && (
                <PayloadSlateRenderer
                    className={classNames(styles.body, classes?.body)}
                    data-intro-body
                    nodes={body}
                />
            )}
        </div>
    );
}

export namespace Intro {
    export interface Props extends IntroType {
        classes?: {
            byline?: string;
            body?: string;
            title?: string;
        };
        className?: string;
        isHero?: boolean;
        hasBackground?: boolean;
    }
}
